import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import RiskRequest from "../riskRequests/RiskRequest";
import RiskChangeRequest from "../riskChangeRequest/RiskChangeRequest";
import "../../../../../src/styles/userManagement.css";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";


import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";
function ManagerRisks() {
  const [currentTab, setCurrentTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState(false);
  const [riskRequestData, setRiskRequestData] = useState([]);
  const [riskChangeRequestData, setRiskChangeRequestData] = useState([]);
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: deleteRiskRequestByIDAPI } = useHttp();
  const { sendRequest: reviewSelectedBusinessImpact } = useHttp();
  const { sendRequest: getRiskRequestData } = useHttp();
  const { sendRequest: getRiskChangeRequestData } = useHttp();

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset);
  };
  const RiskRequestData = async () => {
    getRiskRequestData(APIService.getRiskRequestData(), (data) => {
      data.MSG.forEach(function (a) {
        a.expiray_date = a.expiray_date.substring(0, 10);
        a.date_issued = a.date_issued.substring(0, 10);
      });
      setRiskRequestData(data.MSG);
    });
  };
  const RiskChangeRequestData = async () => {
    getRiskChangeRequestData(APIService.getRiskChangeRequestData(), (data) => {
      data.MSG.forEach(function (a) {
        a.expiray_date = a.expiray_date.substring(0, 10);
        a.date_issued = a.date_issued.substring(0, 10);
      });
      setRiskChangeRequestData(data.MSG);
    });
  };

  const deleteRiskRequestByIDResponse = (result) => {
    if (result.CODE) {
      setLoading(false);
      displayToastMessage(result.MSG, "success");
      RiskChangeRequestData();
    } else {
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const handleDelete = async (vendorId) => {
    setLoading(true);

    await deleteRiskRequestByIDAPI(
      APIService.deleteRiskRequestByID(vendorId),
      deleteRiskRequestByIDResponse,
      (error) => {
        console.log("Error", error);
        setLoading(false);
        displayToastMessage("Something went wrong!", "error");
      }
    );
  };

  const updateRiskRequestById = async (data) => {
    setLoading(true);
    try {
      reviewSelectedBusinessImpact(
        APIService.reviewSelectedBusinessImpact(data),
        (result) => {
          if (result.CODE) {
            displayToastMessage(result.MSG, "success");
            setLoading(false);
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: data.param_business_user_id,
              paramcontent: "Risk request approval",
              paramnextroleid: 1,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            RiskRequestData();
          } else {
            setLoading(false);
            displayToastMessage(
              "Something went wrong, Please try again!",
              "error"
            );
          }
        }
      );
    } catch (error) {
      console.log("Error", error);
      let Msg = "Action failed. Please try again!";
      displayToastMessage(Msg, "error");
    }
  };
  useEffect(() => {
    RiskRequestData();
    RiskChangeRequestData();
  }, []);
  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="Risk Requests">
          <RiskRequest
            reset={reset}
            riskRequestData={riskRequestData}
            updateRiskRequestById={updateRiskRequestById}
            handleDelete={handleDelete}
            loading={loading}
          />
        </Tab>
        <Tab value="2" label="Risk Change Requests">
          <RiskChangeRequest
            exitEdit={reset}
            riskChangeRequestData={riskChangeRequestData}
            SetTab={currentTab}
            handleDelete={handleDelete}
            loading={loading}
          />
        </Tab>
      </Tabs>
    </div>
  );
}
export default ManagerRisks;
